module.exports = __webpack_public_path__ + "static/media/orange-s.6d70ac7f.svg";